// extracted by mini-css-extract-plugin
export var body = "flowStepContainer-module--body--9ad7a";
export var container = "flowStepContainer-module--container--c8751";
export var inner = "flowStepContainer-module--inner--4e003";
export var label = "flowStepContainer-module--label--b1d2b";
export var subtitle = "flowStepContainer-module--subtitle--12d86";
export var title = "flowStepContainer-module--title--4c79c";
export var titleContainer = "flowStepContainer-module--titleContainer--2c8b1";
export var trial = "flowStepContainer-module--trial--5b74c";